// extracted by mini-css-extract-plugin
module.exports = {"cursor":"VisitorSocialCursor_cursor__3LWso","triangle":"VisitorSocialCursor_triangle__p3Qx0","nounHeadImage":"VisitorSocialCursor_nounHeadImage__kUEmJ"};